import { api, uploadWithProgress } from '../client'
import type { Media } from '../types'

interface MediaResponse {
  media: Media
}

export const mediaApi = {
  upload: (file: File, altText?: string) => {
    const form = new FormData()
    form.append('file', file)
    if (altText) form.append('alt_text', altText)
    return api.post<MediaResponse>('/media', form).then((r) => r.media)
  },

  /** 带进度的上传（视频用）；fraction 为 0–1 */
  uploadWithProgress: (file: File, onProgress: (fraction: number) => void) => {
    const form = new FormData()
    form.append('file', file)
    return uploadWithProgress<MediaResponse>('/media', form, onProgress).then((r) => r.media)
  },

  /** 查处理状态：视频转码完才能发（D93） */
  get: (id: string) => api.get<MediaResponse>(`/media/${id}`).then((r) => r.media),

  setAltText: (id: string, altText: string | null) =>
    api.patch<MediaResponse>(`/media/${id}`, { alt_text: altText }).then((r) => r.media),

  remove: (id: string) => api.delete<{ ok: boolean }>(`/media/${id}`),
}
